/** The NAP domain name for ContextVM messages. */
export const DOMAIN = 'cvm' as const;

export type {
  JsonObject,
  JsonSchema,
  McpBlobResourceContents,
  McpContentBlock,
  McpMessage,
  McpResource,
  McpResourceContent,
  McpTextResourceContents,
  McpTool,
  McpToolResult,
  CvmRegistryCallOptions,
  CvmRegistryEntry,
  CvmRegistryOptions,
  CvmRegistryQuery,
  CvmRegistryTool,
} from './cvm-mcp-types.js';
export type {
  CvmDiscoverQuery,
  CvmRequestOptions,
  CvmServer,
  CvmServerRef,
} from './cvm-server-types.js';
export type {
  CvmCloseMessage,
  CvmCloseResultMessage,
  CvmDiscoverMessage,
  CvmDiscoverResultMessage,
  CvmEventMessage,
  CvmInboundMessage,
  CvmMessage,
  CvmNapMessage,
  CvmOutboundMessage,
  CvmRegistryCallMessage,
  CvmRegistryCallResultMessage,
  CvmRegistryDescribeMessage,
  CvmRegistryDescribeResultMessage,
  CvmRegistryHasMessage,
  CvmRegistryHasResultMessage,
  CvmRegistryListMessage,
  CvmRegistryListResultMessage,
  CvmRequestMessage,
  CvmRequestResultMessage,
} from './cvm-message-types.js';
